<template>
  <v-container class="blockchain-orders-container">
    <h1>Blockchain Trades to be transferred</h1>
    <trades-table
      v-if="trades"
      :b-trades="trades"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { BlockchainPendingTradesTable } from '@/components/trades';

export default {
  name: 'BlockchainPendingTrades',
  components: {
    'trades-table': BlockchainPendingTradesTable,
  },
  computed: {
    ...mapState({
      loading: state => state.blockchainPendingTradesStore.loading,
      trades: state => state.blockchainPendingTradesStore.bPendingTrades.map(trade => ({
        ...trade,
        offer: trade.sell_offer ? trade.sell_offer : trade.buy_offer,
        offer_type: trade.sell_offer ? 'Sell offer' : 'Buy offer',
      })),
    }),
  },
  async mounted() {
    this.getBPendingTrades(this.$route.query);
  },
  methods: {
    ...mapActions(['getBPendingTrades']),
  },
};
</script>


<style lang="scss" scoped>
.orderDetails {
  padding-left: 16px;
  padding-right: 16px;
}
.orderField {
  padding: 8px;
}
.transactions {
  max-height: 500px;
  overflow-y: auto;
}
.transactionField {
  padding-top: 8px;
}
.toolbar {
  background-color: #1a4c7d;
}
</style>



// WEBPACK FOOTER //
// src/views/trades/BlockchainPendingTrades.vue